var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSVerificado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5214 0L32.1996 5.68714L38.9646 6.02571L39.3064 12.7896L44.9968 16.4646L41.91 22.4946L45 28.5214L39.3129 32.1996L38.9743 38.9646L32.2104 39.3064L28.5354 44.9968L22.5054 41.91L16.4786 45L12.8004 39.3129L6.03536 38.9743L5.69357 32.2104L0.00321431 28.5354L3.09 22.5054L0 16.4786L5.68714 12.8004L6.02571 6.03536L12.7896 5.69357L16.4646 0.00321431L22.4946 3.09L28.5214 0Z",
    fill: "#42A5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 30.2742L12.749 23.3153L15.0226 21.0428L19.7444 25.7646L29.9958 15.8281L32.2329 18.136L19.7101 30.2742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSVerificado);
export default __webpack_public_path__ + "static/media/SVerificado.1743bca1.svg";
export { ForwardRef as ReactComponent };